<div class="loading-overlay" *ngIf="isLoading">
  <mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>
</div>

<div class="main">
  <div class="header">
    <div class="info">
      <p>Observações</p>
      <div class="tooltip-wrapper">
        <img
          alt="informações"
          src="../../../../../../assets/svg/icons/informacao.svg"
        />
        <div class="custom-tooltip">
          Mensagem de observação registrada no aplicativo.
        </div>
      </div>
    </div>

    <button (click)="close()">
      <img alt="fechar" src="../../../../../../assets/svg/icons/close.svg">
    </button>
  </div>

  <div class="content">
    <p *ngIf="todasObservacoes.length > 0; else nenhumaObs">
      {{ observacaoAtual }}
    </p>
    <ng-template #nenhumaObs>
      <p class="texto-vazio">Nenhuma observação registrada para a refeição selecionada.</p>
    </ng-template>
  </div>

  <div class="paginator-container" *ngIf="todasObservacoes.length > 0">
    <p>Mostrando {{currentIndex + 1}} de {{total}} observações disponíveis</p>

    <div class="simple-paginator">
      <button (click)="previous()" [disabled]="currentIndex === 0">
        <img src="../../../../assets/svg/icons/previous.svg" alt="Anterior">
      </button>

      <span>{{currentIndex + 1}}-{{total}}</span>

      <button (click)="next()" [disabled]="currentIndex === total - 1">
        <img src="../../../../assets/svg/icons/next.svg" alt="Próximo">
      </button>
    </div>
  </div>
</div>
